/** Download .xlsx template aligned with POST /api/leads/import CSV columns. */
export async function downloadLeadsImportTemplate(): Promise<void> {
  const XLSX = await import('xlsx');
  const headers = ['email', 'contact_name', 'company', 'phone', 'website'];
  const example = [
    'info@voorbeeld.nl',
    'Jan de Vries',
    'Voorbeeld B.V.',
    '+31612345678',
    'https://www.voorbeeld.nl',
  ];
  const leadsSheet = XLSX.utils.aoa_to_sheet([headers, example]);
  leadsSheet['!cols'] = [{ wch: 28 }, { wch: 22 }, { wch: 26 }, { wch: 16 }, { wch: 32 }];

  const instructions = XLSX.utils.aoa_to_sheet([
    ['Marketing Hub — bulk import leads'],
    [],
    ['Stappen'],
    ['1. Vul rijen in op het blad "Leads" (minimaal e-mail óf contact_name).'],
    ['2. Verwijder de voorbeeldrij voordat je importeert.'],
    ['3. Importeer via de app:'],
    ['   • Sla op als CSV (UTF-8) en kies het bestand bij Import, of'],
    ['   • Upload dit .xlsx-bestand direct (Excel wordt automatisch omgezet).'],
    [],
    ['Kolommen'],
    ['email — primair dedupe-veld bij upsert'],
    ['contact_name — ook "name" in oudere exports'],
    ['company, phone, website — optioneel'],
  ]);

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, leadsSheet, 'Leads');
  XLSX.utils.book_append_sheet(wb, instructions, 'Instructies');
  XLSX.writeFile(wb, 'marketing-hub-leads-import.xlsx');
}

/** Convert first worksheet of an Excel file to CSV text for the existing import API. */
export async function excelFileToCsvText(file: File): Promise<string> {
  const XLSX = await import('xlsx');
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: 'array' });
  const sheetName = wb.SheetNames[0];
  if (!sheetName) throw new Error('Excel-bestand bevat geen werkblad');
  const sheet = wb.Sheets[sheetName];
  return XLSX.utils.sheet_to_csv(sheet, { FS: ',', RS: '\n' });
}
